module.exports = __webpack_public_path__ + "img/deleteItem.4b366522.gif";